import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { AiOutlineRight, AiOutlineLeft } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';

const Pagination = ({ page = 1, totalPages, changePage, selected = null, elements = null }) => {
  const [hasSelected, setHasSelected] = useState(false);
  const nextPage = () => {
    changePage(page + 1);
  };

  const previousPage = () => {
    changePage(page - 1);
  };

  const { t } = useTranslation(['backoffice']);

  useEffect(() => {
    setHasSelected(selected != null && selected >= 0 && elements > 0);
  }, [selected, elements])

  return (
    <div className={`d-flex pagination mt-3 ${hasSelected ? 'justify-content-between' : 'justify-content-center'}`}>
      {hasSelected && <div className="d-flex m-2 text-light">
        {t('selected')} {selected} {t('of')} {elements}
      </div>}
      <div className='d-flex'>
        <AiOutlineLeft
          onClick={page > 1 ? previousPage : null}
          className={`button ${page > 1 ? 'active' : 'disabled'} m-2`}
          color="white"
        />
        <li className="m-2 text-light list-unstyled">
          {t('page')} {page} {t('of')} {totalPages}
        </li>
        <AiOutlineRight
          onClick={page < totalPages ? nextPage : null}
          className={`button ${page < totalPages ? 'active' : 'disabled'} m-2`}
          color="white"
        />
      </div>
    </div>
  );
};

Pagination.propTypes = {
  page: PropTypes.number,
  totalPages: PropTypes.number,
  changePage: PropTypes.func,
  selected: PropTypes.number,
  elements: PropTypes.number,
};

export default Pagination;
